import React, { useEffect, useRef, useState } from 'react';
import { GetUserEmail, isValidate, SubmitContactUsForm } from '../components/services/api';
import { useNavigate } from 'react-router-dom';

export default function ContactUs() {
    const [userEmail, setUserEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [userMessage, setUserMessage] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const ranOnce = useRef(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (ranOnce.current) return;
        ranOnce.current = true;
        const checkValidation = async () => {
              try {
                const result = await isValidate();
                if (result.d === true) {
                  await getUserEmail();
                }
                else {
                  if (result.d === false) {
                    navigate("/");
                  }
                  else {
                    navigate("/");
                  }
                }
              }
              catch (error) {
                console.log('validation error');
                navigate("/");
              }
            };
        checkValidation();
        
    }, []);
    const getUserEmail = async () => {
        try {
            const response = await GetUserEmail();
            if (response && response.d) {
                setUserEmail(response.d);
            }
        } catch (error) {
            console.error('Error fetching user email:', error);
        }
    };
    const sendMessage = async (e) => {
        e.preventDefault();
        setMessage('');
        setMessageType('');
        try {
            const response = await SubmitContactUsForm(userEmail, subject, userMessage);
            if (response || response.d) {
                setMessage('Your Message sent successfully');
                setMessageType('success');
                setSubject('');
                setUserMessage('');
            }
        } catch (error) {
            setMessageType('error');
            setMessage('There was an error sending your message. Please try again later.');
        }
    }

    return (
        <main className='main-container'>
            <div className='container'>
                <div className='row'>
                    <div className="col-sm-12 p-2 ">
                        <div className='panel-container p-4'>
                            <h5>Contact Us</h5>
                            <form onSubmit={sendMessage} className='row pt-2 gx-2 gy-2'>
                                <div className='mb-3'>
                                    <label htmlFor="email" className='ms-1'>Your Email</label>
                                    <input type="text" className='form-control' disabled value={userEmail} />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor="subject" className='ms-1'>Subject</label>
                                    <input type="text" id='subject' className='form-control' placeholder='Subject' value={subject} onChange={(e) => setSubject(e.target.value)} />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor="message" className='ms-1'>Message</label>
                                    <textarea id='message' rows={4} placeholder='Type Your Message....... ' className='form-control my-input' value={userMessage} onChange={(e) => setUserMessage(e.target.value)} required />
                                </div>
                                {message && <p className={`mt-1 ${messageType === 'success' ? 'text-success' : 'text-danger'}`}>{message}</p>}

                                <div className=''>
                                    <button className='btn btn-custom' type="Submit">Send Your Message</button>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div>

        </main>
    )
}
